/**
 * Create Read More web component.
 * Use this component to render Read More element
 */
if (!customElements.get("sht-read-more")) {
  class SHTReadMore extends HTMLElement {
    constructor() {
      super();
      this.text = this.textContent;
      this.modifiedText = "";
      this.properties = JSON.parse(this.dataset.readMoreProperties);
    }
    bindEventHandlers() {
      let readMoreBtn = this.querySelector(
        `a[data-read-more-properties="read-more"]`
      );
      if (readMoreBtn) {
        readMoreBtn.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            this.innerHTML = this.text;
          }.bind(this)
        );
      }
    }
    connectedCallback() {
      this.limitWords();
      this.innerHTML = this.modifiedText;
      this.bindEventHandlers();
      this.toggleAttribute("hidden", false);
    }

    limitWords() {
      let planText = this.text.replace(/<[^>]*>/g, " ").trim();
      let words = planText.match(/\S+/g);

      let readMoreButton = ` <a href="#" class="read-more tdu" role="button" data-read-more-properties="read-more" aria-label="${this.properties.readMoreText}">${this.properties.readMoreText}</a>`;
      if (words && words.length > this.properties.wordLimit) {
        planText = planText.split(/\s+/, this.properties.wordLimit);
        let allWords = this.text.replace(/></g, "> <").split(/\s+/);
        words = [];

        for (let i = 0; i < allWords.length; i++) {
          if (!planText.length) {
            break;
          }

          let word = allWords[i];
          const realWord = word
            .replace(/<[^>]*>/g, "")
            .replace(/^[^>]*>/g, "")
            .replace(/<[^>]*$/g, "");

          if (
            planText.indexOf(realWord) === 0 ||
            planText.indexOf(realWord.replace(/\W+/g, "")) === 0
          ) {
            planText.splice(0, 1);
          }

          words.push(word);
        }

        words = words.join(" ").replace(/ >/g, ">").replace(/< /g, "<") + "...";

        let tags = words.match(/<[^>]*>/g);

        if (tags) {
          let openTags = [];

          tags.forEach((tag) => {
            if (tag.match(/\/>$/)) {
              return;
            }

            let test = tag.match(/^<([a-zA-Z0-9\-_]+)/);

            if (test) {
              return openTags.push(test[1].toLowerCase());
            }

            test = tag.match(/^<\/([a-zA-Z0-9\-_]+)>/);

            if (
              test &&
              test[1].toLowerCase() === openTags[openTags.length - 1]
            ) {
              return openTags.pop();
            }
          });

          if (openTags.length) {
            openTags.reverse().forEach((tag) => {
              words += `</${tag}>`;
            });
          }
        }
        this.modifiedText = words + readMoreButton;
        return;
      }

      this.modifiedText = this.text;
      return;
    }
  }

  customElements.define("sht-read-more", SHTReadMore);
}
